/**
  Experimental new component - will move to UCL if this is successful
*/
import { Icon, IconButton, Spinner, theme } from '@salecycle/ui-component-library';
import { JustifyContentType, AlignItemsType } from '../ComponentTypes';
import React from 'react';
import styled from 'styled-components';

export interface CardProps {
  children?: React.ReactNode;
  variation?: 'normal' | 'primary';
  width?: string;
  maxWidth?: string;
  minWidth?: string;
  contentPadding?: string;
  contentTextAlign?: string;
  heading?: string;
  headingIcon?: string;
  isLoading?: boolean;
  minHeight?: string;
  justifyContent?: JustifyContentType;
  alignItems?: AlignItemsType;
  closable?: boolean;
  onCloseButtonClicked?: () => void;
}

export const CardElement = styled.div<CardProps>`
  display: grid;
  position: relative;
  border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  min-height: ${props => props.minHeight};
  width: ${props => props.width};
  max-width: ${props => props.maxWidth};
  min-width: ${props => props.minWidth};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
`;

export const HeaderElement = styled.div<CardProps>`
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  background-color: ${props =>
    props.variation === 'primary' ? `${props.theme.vars.newColor.lightGS2}` : 'transparent'};
`;

const HeadingIconElement = styled.span`
  padding-right: 5px;
`;

const SpinnerWrapper = styled.div<CardProps>`
  min-height: ${props => props.minHeight};
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ContentElement = styled.div<CardProps>`
  padding: ${props => props.contentPadding};
  text-align: ${props => props.contentTextAlign};
`;

export const CloseElement = styled.div`
  position: absolute;
  top: 10px;
  right: 5px;
`;

export function LegacyCard(props: CardProps) {
  return (
    <CardElement {...props} data-testid="Card">
      {props.isLoading && (
        <SpinnerWrapper {...props}>
          <Spinner />
        </SpinnerWrapper>
      )}
      {!props.isLoading && props.heading && (
        <HeaderElement {...props}>
          {props.headingIcon && (
            <HeadingIconElement>
              <Icon icon={props.headingIcon} color={theme.vars.newColor.darkGS3} />
            </HeadingIconElement>
          )}
          {props.heading}
        </HeaderElement>
      )}
      {!props.isLoading && props.children && <ContentElement {...props}>{props.children}</ContentElement>}
      {!props.isLoading && props.closable && (
        <CloseElement>
          <IconButton ariaLabel="" icon="times" onClick={props.onCloseButtonClicked} />
        </CloseElement>
      )}
    </CardElement>
  );
}

const defaultProps = {
  contentPadding: '20px',
};

LegacyCard.defaultProps = defaultProps;
